import { ReactNode } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/stores/auth-store";
import { LoadingSpinner } from "@/components/ui/loading-spinner";

interface ProtectedRouteProps {
  children: ReactNode;
  requireAuth?: boolean;
}

export function ProtectedRoute({
  children,
  requireAuth = true,
}: ProtectedRouteProps) {
  const { isAuthenticated, isLoading, user } = useAuth();
  const location = useLocation();

  // Show loading spinner while checking authentication
  if (isLoading) {
    return (
      <div className="flex min-h-screen items-center justify-center">
        <LoadingSpinner size="lg" />
      </div>
    );
  }

  // Redirect to login if not authenticated and auth is required
  // if (requireAuth && !isAuthenticated) {
  //   return <Navigate to="/auth/login" state={{ from: location }} replace />;
  // }

  // Check if user needs to complete onboarding
  // if (isAuthenticated && user && location.pathname !== "/onboarding") {
  //   // You can add onboarding completion check here
  //   // For now, we'll assume user is onboarded
  // }

  return <>{children}</>;
}

export default ProtectedRoute;
